import http from './HttpService';

import { API_BASE_CONTENT, BACKEND_SERVICE_URL } from '../../constants/index';
import { getVersionId } from 'modules/EmailBrowser/utils';
import axios from 'axios';

export function getMyAccountsService() {
  return http.get(API_BASE_CONTENT + 'get_my_accounts/', {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function accountSearchService(keyword: string | string[]) {
  let payload = new FormData();
  let keywordCollection = [...keyword];

  if (typeof keyword == 'string') {
    keywordCollection = keyword.split(',');
  } else {
    keywordCollection = [...keyword];
  }

  for (let item of keywordCollection) {
    payload.append('search', item);
  }
  return http.post(API_BASE_CONTENT + 'get_my_accounts/', payload);
}

export function addAccountService(accountId: number, accountName: string, ticker: string) {
  let payload = new FormData();
  payload.append('id', accountId.toString());
  payload.append('name', accountName);
  payload.append('ticker', ticker);
  payload.append('appName', 'workbench');

  //* For debugging
  // return http.get("https://run.mocky.io/v3/9456b5be-2cef-4022-b4eb-1655ce9f6b78");

  return http.post(BACKEND_SERVICE_URL + '/addcompany/', payload, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function removeAccountService(accountId: number) {
  let payload = new FormData();
  payload.append('companyid', accountId.toString());
  payload.append('appName', 'workbench');

  return http.post(BACKEND_SERVICE_URL + '/deletecompany/', payload, {});
}

let cancelToken: any;
export function getAccountsNewsService(accounts: number[], page = 0, filterIds?: number[], selectAll?: boolean) {
  let versionId = getVersionId();
  let payload = new FormData();
  payload.append('accounts', accounts.join(','));
  payload.append('page', page.toString());
  payload.append('version_id', versionId.toString());
  if (selectAll !== undefined) payload.append('select_all', selectAll.toString());
  if (filterIds) payload.append('filter_ids', filterIds.join(','));

  cancelToken && cancelToken.cancel('Operation canceled due to new request.');

  // save the new request for cancellation
  cancelToken = axios.CancelToken.source();

  return http.post(API_BASE_CONTENT + 'get_accounts_news/', payload, {
    //headers: { "X-CSRFToken": getCSRFToken() },
    cancelToken: cancelToken.token,
  });
}

let cancelTokenFilter: any;
export function getAccountsNewsFilterService() {
  let payload = new FormData();
  payload.append('filters_only', '1');

  cancelTokenFilter && cancelTokenFilter.cancel('Operation canceled due to new request.');

  // save the new request for cancellation
  cancelTokenFilter = axios.CancelToken.source();

  return http.post(API_BASE_CONTENT + 'get_accounts_news/', payload, {
    //headers: { "X-CSRFToken": getCSRFToken() },
    cancelToken: cancelTokenFilter.token,
  });
}
